import React from "react";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import Footer from "../Footerpage/Footer";
import "./Termsandconditions.css";
import CMSTranslationFile from "../Login/Termsandconditions_Translation_Corp.json";
import TranslationFile from "../Translation/Translation_corp.json";
import { Helmet } from "react-helmet";

let userSelectedLanguage = localStorage.getItem("selectedLanguage");

function TermsAndConditons() {
  userSelectedLanguage = localStorage.getItem("selectedLanguage");

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {userSelectedLanguage == "sw"
            ? TranslationFile.FaviconAppText[userSelectedLanguage]
            : TranslationFile.FaviconAppText.en}
        </title>
      </Helmet>

      <HeaderNavBar />
      <div className="content-container">
        <div
          className="termsOfUsageParentDiv"
          // style={{
          //   textAlign: "center",
          //   fontWeight: 500,
          //           }}
        >
          {/* Coming Soon */}

          {/* {CMSTranslationFile.TermsandConditions_Title[userSelectedLanguage]} */}

          <p>
            Följande allmänna användningsvillkor (”Användningsvillkor”) gäller
            vid användning samt köp av digitala tjänster på alla RebelSkool
            webbsidor{" "}
            <a target="_blank" href="https://rebelskool.com">
              https://rebelskool.com
            </a>
            ,{" "}
            <a target="_blank" href="https://apps.rebelskool.com">
              https://apps.rebelskool.com
            </a>{" "}
            (”Webbsida/Webbsidor”).
          </p>

          <strong>Allmänt:</strong>
          <p>
            För att kunna göra ett köp via Webbsidor måste du acceptera
            Användningsvillkoren. Genom att acceptera Användningsvillkoren
            förbinder du dig att följa den i sin helhet, samt godkänner att du
            tagit del av informationen om personuppgifter och samtyckt till
            användningen av cookies. När RebelSkool har bekräftat en beställning
            uppstår ett bindande avtal mellan dig som kund och RebelSkool AB,
            Organisationsnr 559015-5395 ("RebelSkool").
          </p>

          <strong>Priser och betalning:</strong>
          <p>
            Samtliga priser är angivna i svenska kronor inklusive moms. På
            kassasidan där man slutför köpet kan man se det totala priset
            inklusive alla avgifter, moms, frakt och betalning.
          </p>

          <strong>Tryckfel:</strong>
          <p>
            Vi reserverar oss för eventuella tryckfel och felprissättningar på
            Webbsidor och förbehåller oss rätten att avslå ordrar/beställningar.
          </p>

          <strong>Rabattkod:</strong>
          <p>
            Rabattkod gäller så länge som den är giltig eller under en begränsad
            tidsperiod om inte något annat anges. Vi förbehåller oss rätten att
            avslå beställningar om vi känner att ett rabattkod har blivit
            utnyttjade på ett sätt som vi inte godkänner.
          </p>

          <strong>Betalningsalternativ:</strong>
          <p>
            Vi på RebelSkool lagrar inga kort eller bankuppgifter utan allt
            sköts enbart av betalningsleverantören Nets.
          </p>

          <strong>Nets Checkout:</strong>
          <p>
            Betalning sker enkelt och säkert med Nets där du kan betala med
            VISA, MasterCard och bankkort från Swedbank, Handelsbanken, SEB,
            Nordea och Danske Bank. Nets håller höga säkerhetskrav och är
            PCI-certifierade av Trustwave som är en internationell organisation
            för säker e-handel. All trafik krypteras genom SSL 128 bitar och
            alla dataöverföringar bygger på bankernas så kallade 3D-secure
            teknik. Läs mer om Nets här:
            <a target="_blank" href="https://payments.nets.eu/sv-SE">
              https://payments.nets.eu/sv-SE
            </a>
          </p>

          <strong>
            Behandling av Personuppgifter / Integritetspolicy / GDPR:
          </strong>
          <p>
            RebelSkool värnar om Kundens personliga integritet och strävar efter
            att alltid skydda kundens personuppgifter på bästa sätt. Det är
            RebelSkools målsättning och ansvar att följa alla, vid var tid,
            gällande lagar och regler för personuppgiftsskydd. I samband med köp
            eller lämnande av uppgifter samtycker kunden till behandling av
            kundens personuppgifter i enlighet med angivna föreskrifter. Denna
            policy handlar om hur RebelSkool med organisationsnummer 559015-5395
            hanterar dina personuppgifter. Vi värnar om din personliga
            integritet och behandlar dina personuppgifter i enighet med gällande
            lagstiftning och regler för dataskydd.
          </p>

          <strong>Vem är ansvarig för dina personuppgifter?</strong>
          <p>
            RebelSkool AB, Bollvägen 11A, 52360 Gällstad,{" "}
            <a href="mailto:info@rebelskool.com">info@rebelskool.com</a> , är
            ansvarig för behandlingen av dina personuppgifter och att detta sker
            i enlighet med gällande lagstiftning.
          </p>

          <strong>När behandlar vi dina personuppgifter?</strong>
          <p>
            RebelSkool AB samlar in och behandlar dina personuppgifter för att
            du skall kunna handla tjänster eller kontakta oss vid exempelvis
            frågor om användning av våra tjänster. Om du registrerar dig som
            kund hos RebelSkool så behandlar vi information såsom köphistorik.
          </p>

          <strong>Vilka personuppgifter behandlar vi om dig?</strong>
          <p>
            De personuppgifter som RebelSkool samlar in om dig i egenskap av
            kund och behandlar är följande:
            <ul>
              <li>Namn och personnummer eller organisationsnummer.</li>
              <li>Telefonnummer och E-post</li>
              <li>Adress</li>
              <li>Betalningsuppgifter</li>
              <li>Köphistorik</li>
              <li>
                Köpinformation (t.ex. vilka tjänster som köps och används)
              </li>
            </ul>
          </p>

          <strong>För vilka ändamål behandlar vi dina uppgifter?</strong>
          <p>
            RebelSkool behandlar dina personuppgifter för att kunna:
            <ul>
              <li>
                Genomföra och upprätthålla våra förpliktelser och åtaganden till
                dig som kund vid köp, fakturering, kundtjänstärenden och
                serviceärenden
              </li>
              <li>Tillhandahålla våra tjänster och hantera kundrelationer</li>
              <li>
                Ge dig erbjudanden och information via nyhetsbrev och hemsida
              </li>

              <li>Erbjuda dig olika betalningslösningar</li>
              <li>Följa rådande lagstiftning såsom bokföringslagen</li>
              <li>
                Vidare kan uppgifterna komma att användas för att analysera
                köpvanor i syfte att förse kunden med relevant information och
                marknadsföring samt för att förbättra webbplatsen, betalsätt och
                betalningsprocesser.
              </li>
            </ul>
          </p>

          <strong>Laglig grund:</strong>
          <p>
            Fullgörande av köpeavtalet. Denna insamling av dina personuppgifter
            krävs för att vi ska kunna fullgöra våra åtaganden enligt
            köpeavtalet. Om uppgifterna inte lämnas kan våra åtaganden inte
            fullgöras och vi tvingas därför neka dig köpet.
          </p>

          <strong>Hur används uppgifterna?</strong>
          <p>
            Personuppgifter hanteras för att sköta och upprätthålla
            kundrelationer med en kund som registrerats i RebelSkools webbsidor,
            för utveckling och administration av webbsidor, för planering och
            utveckling av affärsrörelsen i den registeransvariga och för
            kundkommunikation och marknadsföring. De personuppgifter som ingår i
            registret kan användas för marknadsföring, direktmarknadsföring,
            inklusive elektronisk marknadsföring, distansförsäljning samt
            marknads- och opinionsundersökningar av RebelSkool AB.
          </p>

          <p>
            Vidare kan uppgifterna komma att användas för att analysera köpvanor
            i syfte att förse kunden med relevant information och marknadsföring
            samt för att förbättra webbsidan, betalsätt och betalningsprocesser.
            Behandling i syfte att förbättra betalsätt och betalningsprocesser
            kan inkludera behandling där kundens personuppgifter, bl.a. kundens
            namn och adress, överförs till andra bolag inom RebelSkools
            samarbetsnät inklusive tredjepartsleverantörer för att ingå som
            analysunderlag. Personuppgifterna kan även komma att samköras med
            uppgifter från andra register (t.ex. kreditupplysningsregister),
            myndigheter eller rättighetshavare. Användningen av uppgifterna kan
            innebära samkörning med andra register, både inom och utom EU, samt
            att kundens personuppgifter överförs till, och behandlas av, andra
            bolag inom RebelSkools samarbetsnät (såsom Nets betalning) inklusive
            tredjepartsleverantörer i tidigare angivna syften i enlighet med
            gällande lagar och regler. RebelSkool iakttar alltid största
            försiktighet vid sådana tillfällen.
          </p>

          <p>
            Genom att godkänna policyn på Webbsidor i samband med köp eller
            lämnande av uppgifter samtycker kunden till att kundens
            personuppgifter kan komma att överföras till ett land utanför EES.
          </p>

          <strong>Hur länge sparas dina personuppgifter?</strong>

          <p>
            När kunden har samtyckt till att vara registrerad kund hos
            RebelSkool sparas kundens uppgifter tills hen avregistrerar sig
            eller under så lång tid som det är nödvändigt med hänsyn till
            ändamålet med behandlingen. RebelSkool kan också komma att spara
            uppgifterna för att kunna bevaka rättsliga intressen, exempelvis
            under en juridisk process.
          </p>

          <strong>Säkerhet till skydd för personuppgifter:</strong>

          <p>
            Säkerheten kring dina personuppgifter är viktig för oss och vi har
            därför vidtagit åtgärder för att skydda dessa. RebelSkool är
            ansvarig för att dina personuppgifter behandlas i enighet med
            rådande lagstiftning. RebelSkool kommer på din begäran eller på eget
            initiativ rätta, komplettera eller avidentifiera uppgifter som
            upptäcks vara felaktiga, missvisande eller ofullständiga. Endast de
            personer som faktiskt behöver behandla dina personuppgifter för att
            vi ska kunna uppfylla våra angivna ändamål har tillgång till dem.
          </p>

          <strong>
            Rätt att begära ut din personuppgifts information & dina
            rättigheter:
          </strong>

          <p>
            Du kan kostnadsfritt begära att få ett utdrag av de uppgifter vi har
            sparat om dig. Enligt personuppgiftslagen har den registrerade rätt
            att få insyn i de uppgifter som sparats i registret om honom. En
            begäran om insyn ska sändas till oss, RebelSkool AB, som sköter
            registerärenden och begäran ska vara skriftlig och undertecknad. En
            begäran om insyn kan också göras personligen hos den
            registeransvarige, RebelSkool AB. Den registrerade har rätt att
            förbjuda att behandla uppgifter som gäller honom själv för
            direktreklam, distansförsäljning och direktmarknadsföring samt för
            marknads- och opinionsundersökningar genom att kontakta den
            registeransvarige. Den registrerade har rätt att kräva att en
            felaktig uppgift rättas till genom att kontakta den
            registeransvarige. Det kan dock finnas lagar och myndighetskrav som
            gör att vi inte omedelbart kan radera dina personuppgifter. Exempel
            på detta kan vara bokförings- eller skattelagstiftning.
          </p>

          <strong>Vid frågor är du välkommen att kontakta oss:</strong>

          <p>
            RebelSkool AB,
            <br />
            Bollvägen 11 A,
            <br />
            52360 Gällstad
            <br />
            E-post:{" "}
            <a href="mailto:info@rebelskool.com">info@rebelskool.com</a>{" "}
          </p>

          <strong>Cookies</strong>
          <p>
            RebelSkool AB använder cookies, en liten textfil från vår webbserver
            som lagras i besökarens dator som innehåller information för att
            hjälpa webbutiken att identifiera och följa användare. Cookies finns
            som sessionscookies och som cookies som lagras permanent på din
            dator. Under tiden för ditt första besök i webbutiken blir din
            webbläsare tilldelad en sessionscookie som är unik och som används
            för att inte blanda ihop dig som användare med andra användare. För
            att kunna använda webbutiken bör du tillåta cookies i din
            webbläsare. Denna typ av cookie används enbart för att ge dig som
            besökare en bättre upplevelse och support och lagrar inga personliga
            uppgifter om dig. Cookies kan raderas. I denna webbutik används
            cookies exempelvis för att hålla koll på din kundvagn, dina
            inställningar och vilka sidor du besökt för att kunna ge dig en
            bättre kundupplevelse och support. Tredjepartsaktörer, som
            exempelvis Google, kan komma att använda dessa cookies för att bland
            annat visa relevanta annonser från{" "}
            <a target="_blank" href="https://rebelskool.com">
              https://rebelskool.com
            </a>
          </p>

          <strong>FORCE MAJEURE</strong>
          <p>
            Händelser som ligger utanför vår kontroll och som skäligen inte
            kunnat förutses, hänföras till Force Majeure, vilket innebär att
            RebelSkool AB befrias från förpliktelser att fullgöra ingångna
            avtal.
          </p>
        </div>
        <br></br>
      </div>
      <ScrolltoTop />
      <Footer />
    </div>
  );
}
export default TermsAndConditons;
